import React from "react";
import { Box } from "@mui/material";

const keyframes = {
  "@keyframes hslFadeUp": {
    from: { opacity: 0, transform: "translateY(8px)" },
    to: { opacity: 1, transform: "none" },
  },
  "@keyframes hslFade": { from: { opacity: 0 }, to: { opacity: 1 } },
};

const reduced = { "@media (prefers-reduced-motion: reduce)": { animation: "none" } };

/** sx for a card that rises in, staggered by its position in a list. */
export const fadeUp = (index = 0, step = 40) => ({
  ...keyframes,
  animation: `hslFadeUp 360ms cubic-bezier(.2,.7,.2,1) both`,
  animationDelay: `${Math.min(index, 8) * step}ms`,
  ...reduced,
});

/** Re-runs a short fade whenever `motionKey` changes (tabs, matchdays, divisions). */
export const FadeSwitch = ({ motionKey, children, sx, rise = true }) => (
  <Box key={motionKey} sx={{ ...keyframes, animation: `${rise ? "hslFadeUp" : "hslFade"} ${rise ? 280 : 600}ms ease both`, ...reduced, ...sx }}>
    {children}
  </Box>
);
